module.exports = __webpack_public_path__ + "static/media/close.d63f8165.svg";